import {Measure} from '@selpia/shared/models';

export class Formatter {
  static formatByMeasure(value: number | undefined | null, measure: Measure | undefined | null, short = false): string {
    if (value === undefined || value === null) {
      return '-';
    }
    let formattedValue = '-';
    if (measure?.classOptions) {
      const separator = ' ';
      const {locales, multiplier, prefix, suffix, ...options} = measure.classOptions;
      formattedValue = (value * (multiplier ?? 1)).toLocaleString(locales, options);
      if (!short) {
        formattedValue = prefix ? `${prefix}${separator}${formattedValue}` : formattedValue;
        formattedValue = suffix ? `${formattedValue}${separator}${suffix}` : formattedValue;
      }
    } else if (!measure?.classOptions) {
      formattedValue = value.toLocaleString();
    }
    return formattedValue;
  }

  static formatByString<T extends Record<string, string>>(formatString: string, data: T): string {
    return formatString.replace(/\${(.*?)}/g, (_, key: keyof T) => data[key] ?? '');
  }
}
